<template>
    <div :class="className" :style="{height:height,width:width}"/>
</template>

<script>
    import echarts from 'echarts'

    require('echarts/theme/macarons') // echarts theme
    import resize from './mixins/resize'

    export default {
        mixins: [resize],
        props: {
            className: {
                type: String,
                default: 'chart'
            },
            width: {
                type: String,
                default: '100%'
            },
            height: {
                type: String,
                default: '360px'
            },
            chartData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                chart: null
            }
        },
        watch: {
            chartData: {
                deep: true,
                handler(val) {
                    this.setOptions(val)
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.initChart()
            })
        },
        beforeDestroy() {
            if (!this.chart) {
                return
            }
            this.chart.dispose()
            this.chart = null
        },
        methods: {
            initChart() {
                this.chart = echarts.init(this.$el, 'macarons')
                this.setOptions(this.chartData)
            },
            setOptions({onlineDevCnt, offlineDevCnt, onlineGWCnt, offlineGWCnt} = {}) {

                this.chart.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    color: ['#2ec7c9', '#ffb980'],
                    legend: {
                        left: 'center',
                        bottom: '10',
                        data: ['在线机柜', '离线机柜']
                    },
                    series: [
                        {
                            name: '',
                            type: 'pie',
                            selectedMode: 'single',
                            center: ['50%', '45%'],
                            radius: [0, '50%'],
                            label: {
                                position: 'inner',
                                fontSize: 14,
                                formatter: '{b}',
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                {value: onlineDevCnt, name: '在线机柜'},
                                {value: offlineDevCnt, name: '离线机柜'},
                            ]
                        },
                    ]
                })
            }
        }
    }
</script>
